import React, { useState } from 'react';
import logo from '../assets/logo.png';

export default function Header() {
    const [isMenuOpen, setIsMenuOpen] = useState(false);

    const toggleMenu = () => {
        setIsMenuOpen(!isMenuOpen);
    };

    return (
        <header className="header">
            <div className="header-container">
                <img src={logo} alt="Swaimsidh Marble" className="logo" />

                {/* Desktop Menu */}
                <nav className="nav-menu desktop-menu">
                    <a href="#home">Home</a>
                    <a href="#collections">Collections</a>
                    <a href="#home">About Us</a>
                    <a href="#contact">Contact</a>
                </nav>

                {/* Mobile Menu Button */}
                <button className="mobile-menu-btn" onClick={toggleMenu}>
                    <span className={`hamburger ${isMenuOpen ? 'open' : ''}`}></span>
                </button>

                {/* Mobile Menu Drawer */}
                <div className={`mobile-menu-drawer ${isMenuOpen ? 'open' : ''}`}>
                    <nav className="mobile-nav">
                        <a href="#home" onClick={toggleMenu}>Home</a>
                        <a href="#collections" onClick={toggleMenu}>Collections</a>
                        <a href="#about" onClick={toggleMenu}>About Us</a>
                        <a href="#contact" onClick={toggleMenu}>Contact</a>
                    </nav>
                </div>
            </div>
        </header>
    );
}
